import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=29a541f6&scoped=true&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=29a541f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a541f6",
  null
  
)

export default component.exports